import React, {Fragment, ReactNode} from "react";

export interface Props {
  tabtitle: string;
  children: ReactNode
}

export const DashboardPanelItem: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Fragment>
      {props.children}
    </Fragment>
  )
};
